var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"mobile-container bg-color-pink",attrs:{"id":"progress-bar-section"}},[_c('div',{staticClass:"bar"},[_c('div',{staticClass:"h-100 bg-page position-relative",style:({width: _vm.percentages + '%'})},[_c('div',{staticClass:"text-center text-light font-weight-bold"},[_vm._v(_vm._s(_vm.percentages)+"%")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }